import { render, staticRenderFns } from "./listaSubstancia.vue?vue&type=template&id=46e3aaba&scoped=true"
import script from "./listaSubstancia.vue?vue&type=script&lang=js"
export * from "./listaSubstancia.vue?vue&type=script&lang=js"
import style0 from "./listaSubstancia.vue?vue&type=style&index=0&id=46e3aaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e3aaba",
  null
  
)

export default component.exports